import { Link } from 'react-router-dom';
import logo from '../../assets/logo.png';

export default function Footer() {
  return (
    <footer className="bg-[#0F172A] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src={logo} 
                alt="Friotec Logo" 
                className="h-16 w-auto object-contain"
              />
              <div className="flex flex-col">
                <span className="text-xl font-bold">Friotec</span>
                <span className="text-xs text-gray-400">Climatização</span>
              </div>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Na Friotec, somos especialistas em instalação, manutenção e reparo de sistemas de ar-condicionado, aquecimento e ventilação.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-[#00A884] transition-colors cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-[#00A884] transition-colors cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-[#00A884] transition-colors cursor-pointer">
                <i className="ri-youtube-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Links Rápidos</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-[#00A884] transition-colors text-sm cursor-pointer">Home</Link></li>
              <li><Link to="/servicos" className="text-gray-400 hover:text-[#00A884] transition-colors text-sm cursor-pointer">Serviços</Link></li>
              <li><Link to="/sobre" className="text-gray-400 hover:text-[#00A884] transition-colors text-sm cursor-pointer">Sobre nós</Link></li>
              <li><Link to="/contato" className="text-gray-400 hover:text-[#00A884] transition-colors text-sm cursor-pointer">Contato</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Serviços</h3>
            <ul className="space-y-2">
              <li><Link to="/servicos" className="text-gray-400 hover:text-[#00A884] transition-colors text-sm cursor-pointer">Instalação de Ar-Condicionado</Link></li>
              <li><Link to="/servicos" className="text-gray-400 hover:text-[#00A884] transition-colors text-sm cursor-pointer">Manutenção Preventiva</Link></li>
              <li><Link to="/servicos" className="text-gray-400 hover:text-[#00A884] transition-colors text-sm cursor-pointer">Serviço de Reparação</Link></li>
              <li><Link to="/servicos" className="text-gray-400 hover:text-[#00A884] transition-colors text-sm cursor-pointer">Aquecimento de Água Solar Térmico</Link></li>
              <li><Link to="/servicos" className="text-gray-400 hover:text-[#00A884] transition-colors text-sm cursor-pointer">Aquecimento de Piscina</Link></li>
              <li><Link to="/servicos" className="text-gray-400 hover:text-[#00A884] transition-colors text-sm cursor-pointer">Manutenção e AQS</Link></li>
              <li><Link to="/servicos" className="text-gray-400 hover:text-[#00A884] transition-colors text-sm cursor-pointer">Ventilação e Climatização</Link></li>
              <li><Link to="/simulador" className="text-gray-400 hover:text-[#00A884] transition-colors text-sm cursor-pointer">Simulador de BTUs</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm">
                <i className="ri-phone-line text-[#00A884] mt-0.5"></i>
                <a href="tel:+351927613501" className="text-gray-400 hover:text-[#00A884] transition-colors cursor-pointer">+351 927 613 501</a>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <i className="ri-mail-line text-[#00A884] mt-0.5"></i>
                <a href="mailto:friotecavac@gmail.com" className="text-gray-400 hover:text-[#00A884] transition-colors cursor-pointer">friotecavac@gmail.com</a>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <i className="ri-time-line text-[#00A884] mt-0.5"></i>
                <span className="text-gray-400">Seg–Sex, 9h–18h</span>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <i className="ri-map-pin-line text-[#00A884] mt-0.5"></i>
                <span className="text-gray-400">Algarve e arredores</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6">
          <div className="flex flex-col lg:flex-row justify-between items-center gap-4 mb-4">
            <div className="flex flex-wrap justify-center lg:justify-start gap-4 text-xs text-gray-400">
              <Link to="/politica-privacidade" className="hover:text-[#00A884] transition-colors cursor-pointer whitespace-nowrap">Política de Privacidade</Link>
              <Link to="/politica-cookies" className="hover:text-[#00A884] transition-colors cursor-pointer whitespace-nowrap">Política de Cookies</Link>
              <a href="https://www.livroreclamacoes.pt" target="_blank" rel="noopener noreferrer" className="hover:text-[#00A884] transition-colors cursor-pointer whitespace-nowrap">Livro de Reclamações</a>
              <Link to="/areas-atendimento" className="hover:text-[#00A884] transition-colors cursor-pointer whitespace-nowrap">Áreas de Atendimento</Link>
            </div>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-xs text-gray-400 hover:text-[#00A884] transition-colors cursor-pointer whitespace-nowrap">
              Website Builder
            </a>
          </div>

          <div className="bg-[#00A884]/10 border border-[#00A884]/20 rounded-lg p-4 mb-4">
            <p className="text-xs text-gray-400 leading-relaxed">
              <i className="ri-information-line text-[#00A884] mr-1"></i>
              A instalação de equipamentos de climatização deve ser realizada por empresas certificadas, conforme o artigo 16.º do Decreto-Lei n.º 145/2017.
            </p>
          </div>

          <div className="text-center text-sm text-gray-400">
            <p>Friotec ® 2025. Todos os direitos reservados.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}